import i18next from 'i18next';
import * as React from 'react';
import { any, fromJSX, StandardLocalWidget } from "widgets-for-react";
import { FormControls } from "../../utils/forms";
import { emptyLanguage, Language, LanguageState, languageStateUpdaters } from "./languageState";

export const languageWidget = (availableLanguages: Array<Language>, readonly?: boolean, suppressHotjar?: boolean): StandardLocalWidget<LanguageState> => currentState =>
  any([
    currentState.validator.widget().map(languageStateUpdaters.validation),
    fromJSX(setState =>
      <FormControls.ShowIf condition={!readonly || currentState.input.Id != undefined}>
        <FormControls.FormSelectInGroup
          key="companyLanguageChoice"
          controlId="companyLanguageChoice"
          label={i18next.t("subscription:Language")}
          required={true}
          readOnly={readonly}
          value={(availableLanguages.find(s => s.Id == currentState.input.Id) || emptyLanguage).Title || ""}
          onChange={(newValue =>
            setState(languageStateUpdaters.input(_ =>
              availableLanguages.find(s => s.Title == newValue) || emptyLanguage
            )
            )
          )}
          validation={currentState.validatorResult.path("Id")}
          suppressHotjar={suppressHotjar}
        >
          {[
            <option value="" disabled={true}>{i18next.t('auth:selectPlaceholder', { entity: i18next.t('subscription:Language').toLowerCase() })}</option>,
            ...availableLanguages.map(s => <option>{s.Title}</option>)
          ]}
        </FormControls.FormSelectInGroup>
      </FormControls.ShowIf>
    )
  ])
